import { atom } from "recoil"
import { ATOMS_KEYS } from "../atom-keys"

export const isManualReservationOpen = atom<boolean>({
	key: ATOMS_KEYS.MANUALRESERVATION,
	default: false,
})
